import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components'

import { meta } from '../../index.js'

export default class lb extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'Ladbrokes')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study"> 

				    <div className="container">

				        <div className="title">

				            <a href="https://ladbrokes.com.au" target="_blank"><img src="/images/new/logos/ladbrokes.svg"/></a>
				            <h3>Bet better in-store</h3>

				            <p>With over 125 years experience in the betting and gaming market, it didn’t take Ladbrokes long to establish their position as Australia’s most innovative bookmaker. By 2015, a solid digital presence had placed them as an online leader, but they were yet to establish a physical bricks-and-mortar presence this side of the pond. </p>

				        </div>

				        <div className="block">

				                <h4>Writing the playbook</h4>
				                <p>Ladbrokes saw the value in providing alternative physical purchase points. Limited by their exclusively digital presence, Ladbrokes were only able to offer their customers online deposit facilities, losing potential customers to competitors offering deposit services through physical storefronts.</p>

						</div>

						<div className="block">

							<h4>Taking odds</h4>
							<p>It wasn’t long before Ladbrokes upped the ante, and took the odds on the blueshyft platform to boost customer acquisition and brand awareness by placing the trifecta:</p>

				            <div className="features">

				                <div className="feature">
				                    <img src="/images/new/icons/wallet-blue.svg"/>
				                    <p>Instant in-store payments</p>
				                </div>
								<div className="feature">
				                    <img src="/images/new/icons/page-blue.svg"/>
				                    <p>In-store customer acquisition</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/promote-blue.svg"/>
				                    <p>Physical & point of sale marketing</p>
				                </div>

				            </div>
				    
				        </div>

				        <div className="block">

				            <h4>All bets are on</h4>
				            <p>In a sprint from mid-June to early August 2015, blueshyft worked to integrate with Ladbrokes’ online and mobile API, introducing three new features into their Australian ecosystem:</p>
				            <p>•  A mobile app-based system - using the blueshyft platform, any customer with a Ladbrokes app can top up their account immediately in-store</p>
							<p>•  In-store acquisition - by building an acquisition form into the platform, blueshyft enabled Ladbrokes customers to sign up and set up an account instantly over the counter</p>
				            <p>•  In-store marketing -  With a reach of over 500,000 customers daily, blueshyft facilitates both digital point-of-sale marketing (content displayed on the iPad screen in-store), as well as physical marketing (window decals, posters and customised in-store display mix packs)</p>


				        </div>

				        <div className="highlight">

				            <p className="highlight-quote">"Partnering with blueshyft has allowed Ladbrokes to offer an industry first Cash-In deposit service to our clients, Australia-wide. The blueshyft app has allowed Australian newsagencies and convenience stores to be the epicentre of this service which provides us with an extensive footprint that spans the country. Additionally, being able to leverage the physical space to advertise the Cash-In service has been fantastic for both this product and our brand."</p>
							<p className="highlight-quote-role">Greg Platz, General Manager @ Ladbrokes</p>
				    
				        </div>

				    </div>

				</section>

				<MoreCaseStudies cases={['goget', 'news', 'sk']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/lb/index.js